'use strict';

DoohApps.filter('MatchingTags', function () {
    return function (tags, searchPhrase, charcountToReturn) {
        var res = [];
        if (typeof (tags) !== 'undefined') {
            var charCount = 0;
            var searchStrings = searchPhrase.replace(',', '').split(' ');
            var taglist = typeof (tags) == 'string' ? tags.split(',') : tags;
            taglist.forEach(function (v) {
                if (searchStrings.includes(v) && charCount + v.length < charcountToReturn) {
                    res.push(v);
                    charCount += v.length;
                }
            });           
        }
        return res;
    }
})